import { createBrowserClient } from '@supabase/ssr'
import { Database, Json } from './database.types'

// Use createBrowserClient for client-side instance
export const supabase = createBrowserClient<Database>(
  process.env.NEXT_PUBLIC_SUPABASE_URL!,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
)

// Simple database types
export type Profile = {
  id: string
  email: string
  full_name: string | null
  company_name: string | null
  avatar_url?: string
  year_founded?: string | null
  employee_count?: string | null
  certifications?: Json | null
  contract_vehicles?: string | null
  
  // New fields
  company_website?: string | null
  company_size?: string | null
  company_duns?: string | null
  company_cage_code?: string | null
  company_naics_codes?: string[] | null
  company_address?: string | null
  company_city?: string | null
  company_state?: string | null
  company_zip?: string | null
  company_country?: string | null
  company_logo_url?: string | null
  business_type?: string[] | null
  capabilities_statement_url?: string | null
  past_performance?: Json | null
  created_at?: string
  updated_at?: string
}

export type Subscription = {
  id: string
  user_id: string
  status: 'active' | 'canceled' | 'past_due'
  tier: string
  stripe_customer_id?: string | null
  stripe_subscription_id?: string | null
  current_period_start?: string | Date | null
  current_period_end?: string | Date | null
  created_at?: string | Date
  updated_at?: string | Date
} 